import React from 'react';

import { ListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import { ContentStreetAntisquat } from './ContentStreetAntisquat';
import { ContentStreetApartment } from './ContentStreetApartment';
import { ContentStreetFurnishedApartments } from './ContentStreetFurnishedApartments';
import { ContentStreetGeneric } from './ContentStreetGeneric';
import { ContentStreetLongTermRentals } from './ContentStreetLongTermRentals';
import { ContentStreetRoom } from './ContentStreetRoom';
import { ContentStreetShortTermRentals } from './ContentStreetShortTermRentals';
import { ContentStreetStudentHousing } from './ContentStreetStudentHousing';
import { ContentStreetStudio } from './ContentStreetStudio';

export interface ContentStreetProps {
  streetName: string;
  cityName: string;
  mainSearchCategory: ListingsSearchCategory;
}

export const ContentStreet = ({
  streetName,
  cityName,
  mainSearchCategory,
}: ContentStreetProps) => {
  switch (mainSearchCategory) {
    case ListingsSearchCategory.Generic:
      return (
        <ContentStreetGeneric streetName={streetName} cityName={cityName} />
      );
    case ListingsSearchCategory.Room:
      return <ContentStreetRoom streetName={streetName} cityName={cityName} />;
    case ListingsSearchCategory.Apartment:
      return (
        <ContentStreetApartment streetName={streetName} cityName={cityName} />
      );
    case ListingsSearchCategory.Studio:
      return (
        <ContentStreetStudio streetName={streetName} cityName={cityName} />
      );
    case ListingsSearchCategory.Antisquat:
      return (
        <ContentStreetAntisquat streetName={streetName} cityName={cityName} />
      );
    case ListingsSearchCategory.StudentHousing:
      return (
        <ContentStreetStudentHousing
          streetName={streetName}
          cityName={cityName}
        />
      );
    case ListingsSearchCategory.FurnishedApartment:
      return (
        <ContentStreetFurnishedApartments
          streetName={streetName}
          cityName={cityName}
        />
      );
    case ListingsSearchCategory.ShortTermRental:
      return (
        <ContentStreetShortTermRentals
          streetName={streetName}
          cityName={cityName}
        />
      );
    case ListingsSearchCategory.LongTermRental:
      return (
        <ContentStreetLongTermRentals
          streetName={streetName}
          cityName={cityName}
        />
      );
    default:
      return null;
  }
};
